module.exports = __webpack_public_path__ + "static/jc04657-preparation-step-02-88ea3a0feab44b8a6fc1fdda937b4882.png";